import React, { forwardRef } from 'react';
import Webcam from 'react-webcam';
import { cn } from 'src/utils/cn';

type Props = {
  onCameraReady?: () => void;
  className?: string;
  rounded?: boolean;
  mirrored?: boolean;
  cameraFacingMode?: 'front' | 'rear';
};

const CaptureImage = forwardRef(function CaptureImage(
  props: Props,
  webCamRef: React.ForwardedRef<Webcam>,
) {
  const { cameraFacingMode = 'rear' } = props;

  const videoConstraints = {
    facingMode: cameraFacingMode === 'rear' ? { exact: 'environment' } : 'user',
  };

  const webCamContainerClass = cn({
    ['flex justify-center flex-1 w-full h-full']: true,
    [props?.className ?? '']: !!props.className,
  });

  const webCamClass = cn({ ['object-cover']: true, ['rounded-30']: props.rounded });

  return (
    <div className={webCamContainerClass}>
      <Webcam
        className={webCamClass}
        screenshotFormat="image/jpeg"
        height="100%"
        width="100%"
        screenshotQuality={1}
        videoConstraints={videoConstraints}
        onUserMedia={props.onCameraReady}
        ref={webCamRef}
        mirrored={props.mirrored}
      />
    </div>
  );
});

export { CaptureImage };
